import React, { Component } from 'react'
import {
  Modal,
  Button
} from 'react-bootstrap'
import { Accordion, AccordionItem } from 'react-light-accordion'
import Titulo from '../../../Utils/containers/Titulo'

class StatusModal extends Component {
  constuctor (props) {
    this.renderMessage = this.renderMessage.bind(this)
    this.renderError = this.renderError.bind(this)
  }

  renderMessage ({ message, extraMessage } = {}) {
    return (
      <div className='status-modal-message'>
        {message}
        <br />
        {extraMessage}
      </div>
    )
  }

  renderMessageConfirmation ({ message } = {}) {
    return (
      <div className='status-modal-message'>
        {message}
        <br />
      </div>
    )
  }

  renderError ({ errorMessage } = {}) {
    return (
      <div className='status-modal-error-message'>
        {errorMessage}
      </div>
    )
  }

  renderExtraError ({ extraErrorMessage } = {}) {
    return (
      <div className='status-modal-error-message'>
        {extraErrorMessage}
      </div>
    )
  }

  render () {
    const {
      onClick,
      message,
      extraMessage,
      errorMessage,
      extraErrorMessage,
      // title = 'Atención',
      show
    } = this.props
    return (
      <div>
        <Modal
          show={show}
          onHide={() => null}>
          <Modal.Header>
            <h3><Titulo /></h3>
          </Modal.Header>
          <Modal.Body>
            {this.renderMessage({ message, extraMessage })}
            {this.renderError({ errorMessage, extraErrorMessage })}
            <br />
            <Accordion atomic={false}>
              <AccordionItem title='Mostrar detalles...'>
                {this.renderExtraError({ extraErrorMessage })}
              </AccordionItem>
            </Accordion>
            <br />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => onClick()} variant='primary'>
              Cerrar...
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
};

export default StatusModal
